/**
 * Os áudios do chat tocam como no WhatsApp (pedido do Igor, 2026-11-03) — o
 * mesmo no ERP e no Cut (`tocador.ts`):
 *  - um por vez: dar play num áudio pausa o que estava tocando;
 *  - a velocidade é uma só: trocar em um troca em todos, e fica guardada
 *    neste aparelho para os próximos.
 */
import { useEffect, useState } from "react";

export const VELOCIDADES = [1, 1.5, 2];
const CHAVE_DA_VELOCIDADE = "pharu.chat.velocidade-dos-audios";

let tocandoAgora = null;
let velocidade = lerVelocidade();
const ouvintes = new Set();

function lerVelocidade() {
  try {
    const v = Number(window.localStorage.getItem(CHAVE_DA_VELOCIDADE));
    return VELOCIDADES.includes(v) ? v : 1;
  } catch {
    return 1;
  }
}

export function velocidadeDosAudios() {
  return velocidade;
}

/** Troca a velocidade de todos os áudios (os abertos mudam na hora). */
export function escolherVelocidade(nova) {
  velocidade = VELOCIDADES.includes(nova) ? nova : 1;
  try {
    window.localStorage.setItem(CHAVE_DA_VELOCIDADE, String(velocidade));
  } catch {
    /* sem storage: vale até fechar a página */
  }
  ouvintes.forEach((f) => f(velocidade));
}

export function proximaVelocidade(atual = velocidade) {
  return VELOCIDADES[(VELOCIDADES.indexOf(atual) + 1) % VELOCIDADES.length];
}

/** Chamado no `play` de um `<audio>`: o que estava tocando pausa. */
export function comecouATocar(elemento) {
  if (tocandoAgora && tocandoAgora !== elemento && !tocandoAgora.paused) tocandoAgora.pause();
  tocandoAgora = elemento;
}

/** Chamado no `pause`/`ended`: esquece o elemento se era ele. */
export function parouDeTocar(elemento) {
  if (tocandoAgora === elemento) tocandoAgora = null;
}

/** A velocidade de todos os áudios, viva: muda em todo balão ao trocar em um. */
export function useVelocidadeDosAudios() {
  const [atual, setAtual] = useState(velocidade);
  useEffect(() => {
    ouvintes.add(setAtual);
    setAtual(velocidade);
    return () => ouvintes.delete(setAtual);
  }, []);
  return atual;
}
